export class VatNumberNotUniqError extends Error {
  constructor(message: string) {
    super(message);
  }
}
